// @flow
import { makeGetRequest } from './utils'

import type { ResponseAPI } from './types/api'
import type { Country } from './types/countries'

export const getCountries = (domain: string): Promise<ResponseAPI<Array<Country>>> =>
  makeGetRequest(`${domain}/client/api/countries`)
